import React, { useEffect, useState } from "react";
import Header from "../Components/Header/Header";
import Footer from "../Components/Footer/Footer";
import "../css/style.css";
import "../css/reset.css";
import "../css/responsive.css";
import "../css/glightbox.css";
import { GetTermAndConditions } from "../services/tripService";
import { useTranslation } from "react-i18next";
import violationsPdf from "../assets/documents/rehla-violations2.pdf";

function TermsOfUse() {
   const { t } = useTranslation();
   const [terms, setTerms] = useState({});

   useEffect(() => {
      termsAndCondition();
   }, []);

   const termsAndCondition = async () => {
      try {
         let { data } = await GetTermAndConditions();
         setTerms(data?.model?.[0] || {});
      } catch (err) {
         console.log(err);
      }
   };

   // ===== حل مشكلة map =====
   const renderList = (key) => {
      const list = t(key, { returnObjects: true });

      if (!Array.isArray(list)) return null;

      return (
         <ul>
            {list.map((item, index) => (
               <li key={index}>{item}</li>
            ))}
         </ul>
      );
   };

   return (
      <>
         <Header />

         {/* ===== Banner ===== */}
         <section
            className="banners"
            style={{ backgroundImage: `url(${"../../images/banners_bg.webp"})` }}
            id="terms-of-use"
         >
            <div className="container">
               <div className="banner_head">
                  <h1>{t("termsOfUse.terms")}</h1>
               </div>

               <div className="bredcrub">
                  <a href="/" target="_self">
                     {t("header.home")}
                  </a>
                  <span>
                     <img src="/images/arrow.png" alt="arrow" />
                  </span>
                  <p>{t("termsOfUse.terms")}</p>
               </div>
            </div>
         </section>

         {/* ===== Terms Section ===== */}
         <section className="term_condition">
            <div className="container">
               <div className="condition_contents">

                  {/* ===== 1 ===== */}
                  <div className="term_heading">
                     <h2>{t("termsOfUse.Title1")}</h2>
                     <p>{t("termsOfUse.Discription1")}</p>
                     {renderList("termsOfUse.List1")}
                  </div>

                  {/* ===== 2 ===== */}
                  <div className="term_heading">
                     <h2>{t("termsOfUse.Title2")}</h2>
                     <p>{t("termsOfUse.Discription2")}</p>
                     {renderList("termsOfUse.List2")}
                  </div>

                  {/* ===== 3 ===== */}
                  <div className="term_heading">
                     <h2>{t("termsOfUse.Title3")}</h2>
                     <p>{t("termsOfUse.Discription3")}</p>
                     {renderList("termsOfUse.List3")}
                  </div>

                  {/* ===== 4 ===== */}
                  <div className="term_heading">
                     <h2>{t("termsOfUse.Title4")}</h2>
                     {renderList("termsOfUse.List4")}
                  </div>

                  {/* ===== 5 ===== */}
                  <div className="term_heading">
                     <h2>{t("termsOfUse.Title5")}</h2>
                     {renderList("termsOfUse.List5")}
                  </div>

                  {/* ===== 6 ===== */}
                  <div className="term_heading">
                     <h2>{t("termsOfUse.Title6")}</h2>
                     {renderList("termsOfUse.List6")}
                  </div>

                  {/* ===== 7 ===== */}
                  <div className="term_heading">
                     <h2>{t("termsOfUse.Title7")}</h2>
                     <p>{t("termsOfUse.Discription7")}</p>
                  </div>

                  {/* ===== 8 ===== */}
                  <div className="term_heading">
                     <h2>{t("termsOfUse.Title8")}</h2>
                     <p>{t("termsOfUse.Discription8")}</p>
                  </div>

                  {/* ===== 8.1 Captain ===== */}
                  <div className="term_heading">
                     <h2>{t("termsOfUse.Title8_1")}</h2>
                     <p>{t("termsOfUse.Discription8_1")}</p>
                     {renderList("termsOfUse.List8_1")}
                  </div>

                  {/* ===== 8.2 Car ===== */}
                  <div className="term_heading">
                     <h2>{t("termsOfUse.Title8_2")}</h2>
                     <p>{t("termsOfUse.Discription8_2")}</p>
                     {renderList("termsOfUse.List8_2")}
                  </div>

                  {/* ===== 8.3 Passenger ===== */}
                  <div className="term_heading">
                     <h2>{t("termsOfUse.Title8_3")}</h2>
                     <p>{t("termsOfUse.Discription8_3")}</p>
                     {renderList("termsOfUse.List8_3")}
                  </div>

                  {/* ===== 9 ===== */}
                  <div className="term_heading">
                     <h2>{t("termsOfUse.Title9")}</h2>
                     <p>{t("termsOfUse.Discription9")}</p>
                  </div>

                  {/* ===== 10 ===== */}
                  <div className="term_heading">
                     <h2>{t("termsOfUse.Title10")}</h2>
                     <p>{t("termsOfUse.Discription10")}</p>
                  </div>

                  <div className="term_heading">
                     <h2>{t("termsOfUse.Title10_1")}</h2>
                     <p>{t("termsOfUse.Discription10_1")}</p>
                  </div>

                  <div className="term_heading">
                     <h2>{t("termsOfUse.Title10_2")}</h2>
                     <p>{t("termsOfUse.Discription10_2")}</p>
                  </div>

                  <div className="term_heading">
                     <h2>{t("termsOfUse.Title10_3")}</h2>
                     <p>{t("termsOfUse.Discription10_3")}</p>
                  </div>

                  {/* ===== 11 ===== */}
                  <div className="term_heading">
                     <h2>{t("termsOfUse.Title11")}</h2>
                     <p>{t("termsOfUse.Discription11")}</p>
                     {renderList("termsOfUse.List11_1")}
                  </div>

                  {/* ===== 12 ===== */}
                  <div className="term_heading">
                     <h2>{t("termsOfUse.Title12")}</h2>
                     <p>{t("termsOfUse.Discription12")}</p>
                  </div>

                  {/* ===== 13 ===== */}
                  <div className="term_heading">
                     <h2>{t("termsOfUse.Title13")}</h2>
                     <p>{t("termsOfUse.Discription13")}</p>
                  </div>

                  <div className="term_heading">
                     <h2>{t("termsOfUse.Title13_1")}</h2>
                     {renderList("termsOfUse.List13_1")}
                  </div>

                  <div className="term_heading">
                     <h2>{t("termsOfUse.Title13_2")}</h2>
                     {renderList("termsOfUse.List13_2")}
                  </div>

                  <div className="term_heading">
                     <h2>{t("termsOfUse.Title13_3")}</h2>
                     {renderList("termsOfUse.List13_3")}
                  </div>

                  {/* ===== 14 ===== */}
                  <div className="term_heading">
                     <h2>{t("termsOfUse.Title14")}</h2>
                     {renderList("termsOfUse.List14")}
                  </div>

                  {/* ===== 15 ===== */}
                  <div className="term_heading">
                     <h2>{t("termsOfUse.Title15")}</h2>
                     <p>{t("termsOfUse.Discription15")}</p>
                  </div>

                  {/* ===== 16 ===== */}
                  <div className="term_heading">
                     <h2>{t("termsOfUse.Title16")}</h2>
                     <p>{t("termsOfUse.Discription16")}</p>
                     {renderList("termsOfUse.List16")}
                  </div>

                  {/* ===== 17 ===== */}
                  <div className="term_heading">
                     <h2>{t("termsOfUse.Title17")}</h2>
                     <p>{t("termsOfUse.Discription17")}</p>
                  </div>

                  {/* ===== 18 ===== */}
                  <div className="term_heading">
                     <h2>{t("termsOfUse.Title18")}</h2>
                     <p>{t("termsOfUse.Discription18")}</p>
                  </div>

                  {/* ===== 19 ===== */}
                  <div className="term_heading">
                     <h2>{t("termsOfUse.Title19")}</h2>
                     <p>{t("termsOfUse.Discription19")}</p>
                     {renderList("termsOfUse.List19")}
                  </div>

                  {/* ===== 20 ===== */}
                  <div className="term_heading">
                     <h2>{t("termsOfUse.Title20")}</h2>
                     <p>{t("termsOfUse.Discription20")}</p>
                  </div>

                  {/* ===== 21 ===== */}
                  <div className="term_heading">
                     <h2>{t("termsOfUse.Title21")}</h2>
                     <p>{t("termsOfUse.Discription21")}</p>
                  </div>

                  {/* ===== 22 ===== */}
                  <div className="term_heading">
                     <h2>{t("termsOfUse.Title22")}</h2>
                     <p>{t("termsOfUse.Discription22")}</p>
                  </div>

                  {/* ===== 23 ===== */}
                  <div className="term_heading">
                     <h2>{t("termsOfUse.Title23")}</h2>
                     <p>{t("termsOfUse.Discription23")}</p>
                  </div>

                  {/* ===== 24 ===== */}
                  <div className="term_heading">
                     <h2>{t("termsOfUse.Title24")}</h2>
                     <p>{t("termsOfUse.Discription24")}</p>
                  </div>

                  {/* ===== 25 ===== */}
                  <div className="term_heading">
                     <h2>{t("termsOfUse.Title25")}</h2>
                     <p>
                        {t("termsOfUse.Discription25")}
                        <br />
                        <a
                           href={violationsPdf}
                           download
                           target="_blank"
                           rel="noopener noreferrer"
                           style={{
                              color: "#635bff",
                              fontWeight: 600,
                              textDecoration: "none",
                              borderBottom: "2px solid transparent",
                              transition: "0.2s"
                           }}
                           onMouseEnter={(e) => (e.target.style.borderBottom = "2px solid #635bff")}
                           onMouseLeave={(e) => (e.target.style.borderBottom = "2px solid transparent")}
                        >
                           {t("termsOfUse.DownloadViolations")}
                        </a>
                     </p>
                  </div>

               </div>
            </div>
         </section>

         <Footer />
      </>

   );
}

export default TermsOfUse;